import { Autocomplete, TextField } from '@mui/material';
import { useAppTFunction } from '@retail/app/i18n';
import { CustomerAssortmentOption } from '../CustomerAssortmentSelect';

interface Props {
  label: string;
  customerAssortments: CustomerAssortmentOption[];
  value: number | null | undefined;
  onChange: (assortmentId: number | null) => void;
  disabled?: boolean;
}

export function CustomerTemplateSelect({
  label,
  customerAssortments,
  value,
  onChange,
  disabled,
}: Props) {
  const t = useAppTFunction();

  return (
    <Autocomplete
      options={customerAssortments}
      size="small"
      disabled={disabled}
      isOptionEqualToValue={(option, selected) => option.assortmentId === selected.assortmentId}
      value={customerAssortments.find(({ assortmentId }) => assortmentId === value) ?? null}
      onChange={(_, newValue) => onChange(newValue?.assortmentId ?? null)}
      getOptionLabel={(option) => option.name}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={t('app.createCustomer.template.placeholder')}
        />
      )}
    />
  );
}
